module.exports = __webpack_public_path__ + "static/img/37.0c6b880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/37.png
// module id = W9Rg
// module chunks = 1